export const BikeDefectRestrictRentalsCountingMode = {
  sameBikePart: {
    name: 'Ten sam problem',
    value: 'sameBikePart',
  },
  anyEligibleDefect: {
    name: 'Dowolne kwalifikujące się zgłoszenia',
    value: 'anyEligibleDefect',
  },
}
